import { observer, React, RouteComponentProps } from "aaa";
import * as FileSaver from "file-saver";
import * as gitVersion from "gitVersion";
import { pushRoute } from "stores/RouterFunctions";

@observer
export default class Component extends React.Component<RouteComponentProps<{}>, {}> {
    render() {
        // const pathComponents = window.location.href.split("#");

        const url = "testpdf.pdf";

        // debug.log("### root", pathComponents[0]);
        return (
            <div>
                <div style={{ fontSize: 16, background: "silver", padding: 10 }}>
                    branch: {gitVersion.GIT_BRANCH} - version: {gitVersion.GIT_VERSION}
                </div>

                <div style={{ padding: 20, fontSize: 20 }}>
                    <a href={url}>1) Direkter Link, funktioniert auf allen Plattformen</a>

                    <br /><br />

                    <span
                        style={{
                            textDecoration: "underline",
                            color: "blue",
                            cursor: "pointer"
                        }}
                        onClick={async () => {
                            const response = await fetch(url);
                            const blob = await response.blob();
                            const pdfUrl = URL.createObjectURL(blob);
                            pushRoute("/pdf/" + encodeURIComponent(pdfUrl));
                        }}
                    >
                        2) Blob Anzeige, funtioniert auf Desktop (außer IE) und iOS
                    </span>

                    <br /><br />

                    <span
                        style={{
                            textDecoration: "underline",
                            color: "blue",
                            cursor: "pointer"
                        }}
                        onClick={async () => {
                            const response = await fetch(url);
                            const blob = await response.blob();
                            FileSaver.saveAs(blob, "testpdf.pdf");
                        }}
                    >
                        3) Blob Download, funtioniert auf Desktop, Android Browser (nicht Webview) und eingeschränkt iOS
                    </span>
                </div>
            </div >
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/test/PdfTest.tsx